// extracted by mini-css-extract-plugin
export var backdropBlur = "_gv-0";
export var contentCard = "_gv-5";
export var frame = "_gv-2";
export var image = "_gv-4";
export var imagePane = "_gv-3";
export var modal = "_gv-1";